import { types } from '../actions/types';

const DEFAULT_STATE = {
    credits: null
};

export default (state = DEFAULT_STATE, action) => {
    switch (action.type) {
        case types.GET_CREDITS_SUCCESS:
            return {
                ...state, credits: action.payload
            }
        case types.CREDITS_PAYMENT_SUCCESS:
            return {
                ...state, credits: action.payload
            }
        case types.CREDITS_PAYMENT_FAIL:
            return {
                ...state, credits: action.payload
            }
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/js/reducers/payment-reducer.js